import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { fonts, responsiveText, spacing } = theme;

export const tabList = css`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: ${spacing.xl}px;
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  column-gap: ${spacing.xl}px;
  border-bottom: 2px solid var(--neutral-black-10);
`;

export const tabLink = css`
  ${responsiveText.BODY.MD};
  display: block;
  padding: ${spacing.sm}px 0;
  text-decoration: none;
  color: var(--neutral-black-base);
  margin-left: ${spacing.lg}px;

  &:hover:not([aria-current='page']) {
    border-bottom: 2px solid var(--neutral-black-40);
    color: var(--neutral-black-base);
    margin-bottom: -2px;
  }

  &[aria-current='page'] {
    border-bottom: 2px solid var(--brand-purple-base);
    color: var(--brand-purple-base);
    margin-bottom: -2px;
  }
`;

export const tabPanel = css`
  width: 100%;
  font-weight: 400;

  &[aria-current='page'] {
    display: block;
  }

  &:not([aria-current='page']) {
    display: none;
  }
`;
